import { PayoutSettings } from "@wingspanhq/wingspan-api-sdk";
import { selectorPayoutSettingsInstantFee } from "@selectors/selectorPayoutSettingsInstantFee";

/**
 * Used only for the invoice fee arithmetic, where a number is required and the
 * callers already gate rendering on resolved payout settings. Fee *copy* must
 * withhold the percentage instead of falling back — see
 * selectorInstantPayoutFeeLabel.
 */
export const FALLBACK_INSTANT_PAYOUT_FEE_PERCENTAGE = 1;

class InstantPayoutService {
  calculateInvoiceInstantPayoutFee(
    amount: number,
    payoutSettings?: PayoutSettings
  ) {
    const instantPayoutDefaultFee =
      selectorPayoutSettingsInstantFee(payoutSettings) ??
      FALLBACK_INSTANT_PAYOUT_FEE_PERCENTAGE;
    const instantPayoutDefaultFeeMultiplier = instantPayoutDefaultFee / 100;

    const instantPayoutFee = amount * instantPayoutDefaultFeeMultiplier;

    // Prevent setting 0.5 if the fee amount is 0
    if (instantPayoutFee === 0) {
      return 0;
    }

    if (instantPayoutFee < 0.5) {
      return 0.5;
    }

    return instantPayoutFee;
  }
}

export const instantPayoutService = new InstantPayoutService();
